export type MappingType = 'evidenceOnly' | 'summaryOnly' | 'summaryAndEvidence' | 'diseaseBased';

export const evidenceOnlyColumnNames: string[] = [
  'numPMIDsupportingAssociation',
  'numCTs',
  'numberPmidsWithChemsIncludedInEvidence',
  'numberNCTSWithChemsIncludedInEvidence',
  'chemNumPublicationsGDA',
  'chemNumPublicationsVDA',
];

export const summaryOnlyColumnNames: string[] = [
  'ngenes_diseaseID_1',
  'ngenes_diseaseID_2',
  'nvariants_diseaseID_1',
  'nvariants_diseaseID_2',
  'shared_genes',
  'numChemicals',
];

export const summaryAndEvidenceColumnNames: string[] = [
  'numDBSNPsupportingAssociation',
  'numberChemsIncludedInEvidence',
  'nvariants_diseaseID_shared',
  'ngenes_diseaseID_shared',
];

export const diseaseBasedColumnNames: string[] = [
  'ngenes_diseaseID_1',
  'ngenes_diseaseID_2',
  'nvariants_diseaseID_1',
  'nvariants_diseaseID_2',
  'nvariants_diseaseID_shared',
  'ngenes_diseaseID_shared',
];

const evidenceOnlySet = new Set(evidenceOnlyColumnNames);
const summaryOnlySet = new Set(summaryOnlyColumnNames);

export function getMappingType(columnName: string | undefined): MappingType {
  if (!columnName) return 'summaryAndEvidence';
  if (evidenceOnlySet.has(columnName)) return 'evidenceOnly';
  if (summaryOnlySet.has(columnName)) return 'summaryOnly';
  return 'summaryAndEvidence';
}

export function isEvidenceOnlyMapping(columnName: string | undefined): boolean {
  return getMappingType(columnName) === 'evidenceOnly';
}

export function isSummaryAndEvidenceMapping(columnName: string | undefined): boolean {
  return getMappingType(columnName) === 'summaryAndEvidence';
}

export function isSummaryOnlyMapping(columnName: string | undefined): boolean {
  return getMappingType(columnName) === 'summaryOnly';
}
